import React, { useEffect, useState } from 'react';

import { Box, Button, Grid, Modal, Skeleton, Typography } from '@mui/material';
import { getObstacleThumbnailWindow } from 'core/utils/obstacles';

import CircularLoader from "../../../tools/CircularLoader";
import CloseButton from '../../../tools/CloseButton';

export default function ObstacleModal(props) {
  const {
    t,
    getObstacleThumbnails,
    isLoadingObstacleThumbnails,
    obstacleThumbnails,
    setIsModalOpen,
    isModalOpen,
    handleChange,
    value,
    currentSessionObstaclesInfo,
  } = props;

  const [currentObstacle, setCurrentObstacle] = useState(null);
  const [obstacleIndex, setObstacleIndex] = useState(null);
  const [isThumbnailLoading, setIsThumbnailLoading] = useState(true);
  const [currentValues, setCurrentValues] = useState([]);

  const fetchThumbnailWindow = () => {
    const values = getObstacleThumbnailWindow(value, currentSessionObstaclesInfo?.obstacles?.length);
    if (values.length === 0) return;

    setCurrentValues(values);
    getObstacleThumbnails(JSON.stringify(currentSessionObstaclesInfo?.obstacles), JSON.stringify(values), JSON.stringify(obstacleThumbnails));
  };

  useEffect(() => {
    if (!Array.isArray(obstacleThumbnails)) {
      fetchThumbnailWindow();
    } else {
      const doesNotExist = !(obstacleThumbnails?.some(obs => obs.value === value));

      if (value !== obstacleIndex && doesNotExist) {
        fetchThumbnailWindow();
      }
    }

    const obstacle = obstacleThumbnails?.find(obs => obs.value === value);
    if (obstacle) {
      setCurrentObstacle(obstacle);
      setObstacleIndex(value);
    }
  }, [value, currentObstacle, obstacleThumbnails]);

  useEffect(() => {
    setIsThumbnailLoading(true);
    if (!isLoadingObstacleThumbnails) {
      setTimeout(() => {
        setIsThumbnailLoading(false)
      }, 800)
    }
  }, [value])

  const goToPreviousObstacle = () => {
    if (obstacleIndex !== null) {
      const newValue = obstacleIndex > 0 ? obstacleIndex - 1 : currentSessionObstaclesInfo?.obstacles.length - 1;
      handleChange(null, newValue, currentSessionObstaclesInfo?.obstacles[newValue]);
    }
  };

  const goToNextObstacle = () => {
    if (obstacleIndex !== null) {
      const newValue = obstacleIndex < currentSessionObstaclesInfo?.obstacles.length - 1 ? obstacleIndex + 1 : 0;
      setIsThumbnailLoading(true);
      handleChange(null, newValue, currentSessionObstaclesInfo?.obstacles[newValue]);
      setIsThumbnailLoading(false);
    }
  };

  const handleNoImage = () => {
    if (currentValues?.length) {
      getObstacleThumbnails(JSON.stringify(currentSessionObstaclesInfo?.obstacles), JSON.stringify(currentValues), JSON.stringify([]))
      const obstacle = obstacleThumbnails?.find(obs => obs.value === value);
      if (obstacle) {
        setCurrentObstacle(obstacle);
        setObstacleIndex(value);
      }
    }
  }

  return (
    <Modal open={isModalOpen}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          borderRadius: '10px',
          boxShadow: 24,
          width: isLoadingObstacleThumbnails ? 'auto' : '45vw',
          px: 2,
        }}
      >
        <Grid container item justifyContent='flex-end' alignItems='center' mt={1} sx={{ position: 'absolute', right: '1%' }}>
          <CloseButton setIsOpen={setIsModalOpen} isColorbgAlwaysDark={false} />
        </Grid>
        {isLoadingObstacleThumbnails ? (
          <Grid m={3}>
            <CircularLoader />
          </Grid>
        ) : (
          <>
            <Grid container item justifyContent='start' mt={2} ml={1}>
              {currentSessionObstaclesInfo?.obstacles[value].permanent ? (
                <Typography variant='h6'>{t('cws_app.digital_store.constant_obstacle', 'Constant obstacle')} - {currentSessionObstaclesInfo?.obstacles[value].timestamp.split('T')[1]}</Typography>
              ) : (
                <Typography variant='h6'>{t('cws_app.digital_store.day_obstacle', 'Day obstacle')} - {currentSessionObstaclesInfo?.obstacles[value].timestamp.split('T')[1]}</Typography>
              )}
            </Grid>
            <Grid container item alignItems='flex-start' justifyContent='space-between' flexDirection='row' my={1}>
              <Grid ml={1}>
                <Grid container item flexDirection='column' sx={{ paddingTop: '16px !important' }}>
                  <Typography color="textSecondary" mb={1}>{t('cws_app.Walls.aisle', 'Aisle')}</Typography>
                  <Typography mb={1}>{currentSessionObstaclesInfo?.obstacles[value].aisle}</Typography>
                </Grid>
                <Grid container item flexDirection='column' sx={{ paddingTop: '16px !important' }}>
                  <Typography color="textSecondary" mb={1}>{t('cws_app.digital_store.frontal_view', 'Frontal view')}</Typography>
                  {isThumbnailLoading ?
                    (
                      <Skeleton variant='rectangular' width='260px' height='180px' />
                    )
                    :
                    (
                      <img src={currentObstacle?.frontal_cam} alt='Obstacle front cam thumbnail' style={{ width: '260px', height: '180px' }} />
                    )

                  }
                </Grid>
              </Grid>
              <Grid mx={1}>
                <Grid container item flexDirection='column' sx={{ paddingTop: '16px !important' }}>
                  <Typography color="textSecondary" mb={1}>{t('cws_app.digital_store.mode', 'Mode')}</Typography>
                  {currentSessionObstaclesInfo?.obstacles[value].mode === 'waf' ? (
                    <Typography mb={1}>{t('cws_app.digital_store.data_capture', 'Data capture')}</Typography>
                  ) : (
                    <Typography mb={1}>{t('cws_app.dashboards.Navigation', 'Navigation')}</Typography>
                  )}
                </Grid>
                <Grid container item flexDirection='column' sx={{ paddingTop: '16px !important' }}>
                  <Typography color="textSecondary" mb={1}>{t('cws_app.digital_store.floor_view', 'Floor view')}</Typography>
                  {isThumbnailLoading ?
                    (
                      <Skeleton variant='rectangular' width='260px' height='180px' />
                    )
                    :
                    (
                      <img src={currentObstacle?.lower_cam} alt='Obstacle lower cam thumbnail' style={{ width: '260px', height: '180px' }} onError={handleNoImage} />
                    )

                  }
                </Grid>
              </Grid>

            </Grid>
            {value === 0 &&
              <Grid container item justifyContent='flex-end' mb={1}>
                <Button onClick={goToNextObstacle}>{t('cws_app.digital_store.next_obstacle', 'Next obstacle')}</Button>
              </Grid>
            }

            {value === currentSessionObstaclesInfo?.obstacles?.length - 1 &&
              <Grid container item justifyContent='flex-start' mb={1}>
                <Button onClick={goToPreviousObstacle}>{t('cws_app.digital_store.previous_obstacle', 'Previous obstacle')}</Button>
              </Grid>
            }

            {value !== 0 && value !== currentSessionObstaclesInfo?.obstacles?.length - 1 &&
              <Grid container item justifyContent='space-between' mb={1}>
                <Button onClick={goToPreviousObstacle}>{t('cws_app.digital_store.previous_obstacle', 'Previous obstacle')}</Button>
                <Button onClick={goToNextObstacle}>{t('cws_app.digital_store.next_obstacle', 'Next obstacle')}</Button>
              </Grid>
            }
          </>
        )
        }
      </Box>
    </Modal>
  )
};